/*
Drawn by a filmstrip card before its JPEG enters the load window and behind a main image that
failed to load. A transparent 1x1 GIF draws nothing and needs no request. The previous value was
a relative path to an asset that was never bundled, so every use cost a 404 and a broken image.
*/
export const PLACEHOLDER_IMAGE_SRC =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
